<template>
    <div class="ui-body">
        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-content">
            <div class="ui-content">
                <!-- 02.03.主体容器 - 内容 - 普通面板 Start -->
                <el-form class="ui-container-form" ref="formContent" :model="formContent" :label-width="formWidth"
                         :label-position="formPosition" :rules="formRules">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="ui-form-panel">
                                <h4>上级权限</h4>
                                <div class="ui-tree">
                                    <div class="ui-tree-search">
                                        <el-input placeholder="请输入搜索内容" v-model="searchValue" clearable></el-input>
                                    </div>
                                    <div class="ui-tree-content">
                                        <el-scrollbar>
                                            <el-tree ref="tree" :data="tree_data" :props="treeConfig"
                                                     :highlight-current="true" :expand-on-click-node="false"
                                                     default-expand-all :filter-node-method="searchFilter"
                                                     @node-click="powerClick"></el-tree>
                                        </el-scrollbar>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="ui-form-panel">
                                <el-scrollbar>
                                    <h4>基础信息</h4>
                                    <el-row :gutter="20">
                                        <el-col>
                                            <el-form-item label="权限分类" prop="power_class">
                                                <el-radio-group v-model="formContent.power_class" size="medium">
                                                    <el-radio-button :label="1">系统级</el-radio-button>
                                                    <el-radio-button :label="2">页面级</el-radio-button>
                                                    <el-radio-button :label="3">功能级</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="权限编码" prop="code">
                                                <el-input v-model="formContent.code"
                                                          placeholder="请输入权限编码"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="权限标题" prop="title">
                                                <el-input v-model="formContent.title"
                                                          placeholder="请输入权限标题"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="4">
                                            <el-form-item label="排序" prop="sort">
                                                <el-input v-model="formContent.sort" placeholder="请输入排序"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item label="导航路径" prop="path">
                                                <el-input v-model="formContent.path"
                                                          placeholder="请输入导航路径"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="导航图标" prop="icon">
                                                <el-select v-model="formContent.icon" placeholder="请选择导航图标"
                                                           filterable clearable>
                                                    <el-option class="ui-option" :key="index" :value="item"
                                                               :label="item" v-for="(item,index) in iconOption">
                                                        <i :class="item"></i>
                                                        <span>{{ item }}</span>
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="24">
                                            <el-form-item label="权限说明" prop="content">
                                                <quill-editor :options="this.$editor" v-model="formContent.content"
                                                              style="height: 220px"/>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-scrollbar>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 02.03.主体容器 - 内容 - 普通面板 End -->
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->

        <!-- 03.主体容器 - 尾部 Start -->
        <div class="ui-container-footer ">
            <!-- 03.01.主体容器 - 尾部 - 按钮 Start -->
            <div class="ui-container-footer-group" v-if="$Permissions(['PowerPatch','PowerCreate'])">
                <el-button type="primary" @click="formSubmit"><i class="ion-ios-add-circle"></i>{{ htmlSubmit }}
                </el-button>
                <el-button @click="onReset"><i class="ion-ios-refresh-circle"></i>重置</el-button>
            </div>
            <!-- 03.01.主体容器 - 尾部 - 按钮 End -->
        </div>
        <!-- 03.主体容器 - 尾部 End -->
    </div>
</template>

<script>
    export default {
        name: "add_power",
        data() {
            return {
                // 01.显示模式 ------------------------------------------------
                // 01.01.Html标题
                htmlTitle: this.$route.meta.title,
                // 01.02.Html描述
                htmlDescription: this.$route.meta.description,
                // 01.03.Html按钮标题
                htmlSubmit: "添加",
                // 02.Form 配置/数据集 ------------------------------------------------
                // 02.01.Form提交API地址
                formAPI: '/api/create/power/',
                // 02.01.Form配置 - 标题位置
                formPosition: 'top',
                // 02.01.Form配置 - 标题宽度
                formWidth: '130px',
                // 02.02.Form数据集
                formContent: {
                    power_class: 3,
                    parent: '',
                    title: '',
                    code: '',
                    content: '',
                    path: '',
                    icon: '',
                    sort: '0'
                },
                // 02.03.Form 验证
                formRules: {
                    title: [
                        {required: true, message: '请输入权限标题', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '请输入权限编码', trigger: 'blur'}
                    ]
                },
                // 03.树状框数据集 ------------------------------------------------
                // 03.01.权限数组
                tree_data: [],
                // 03.02.树状框搜索框
                searchValue: '',
                // 03.03.树状框配置
                treeConfig: {
                    children: 'children',
                    label: 'label'
                },
                // 04.其他数据集 ------------------------------------------------
                iconOption: [
                    "ion-ios-add-circle",
                    "ion-ios-add-circle-outline",
                    "ion-ios-alarm",
                    "ion-ios-albums",
                    "ion-ios-alert",
                    "ion-ios-american-football",
                    "ion-ios-analytics",
                    "ion-ios-aperture",
                    "ion-ios-apps",
                    "ion-ios-appstore",
                    "ion-ios-archive",
                    "ion-ios-arrow-back",
                    "ion-ios-arrow-down",
                    "ion-ios-arrow-dropdown",
                    "ion-ios-arrow-dropdown-circle",
                    "ion-ios-arrow-dropleft",
                    "ion-ios-arrow-dropleft-circle",
                    "ion-ios-arrow-dropright",
                    "ion-ios-arrow-dropright-circle",
                    "ion-ios-arrow-dropup",
                    "ion-ios-arrow-dropup-circle",
                    "ion-ios-arrow-forward",
                    "ion-ios-arrow-round-back",
                    "ion-ios-arrow-round-down",
                    "ion-ios-arrow-round-forward",
                    "ion-ios-arrow-round-up",
                    "ion-ios-arrow-up",
                    "ion-ios-at",
                    "ion-ios-attach",
                    "ion-ios-backspace",
                    "ion-ios-barcode",
                    "ion-ios-baseball",
                    "ion-ios-basket",
                    "ion-ios-basketball",
                    "ion-ios-battery-charging",
                    "ion-ios-battery-dead",
                    "ion-ios-battery-full",
                    "ion-ios-beaker",
                    "ion-ios-beer",
                    "ion-ios-bicycle",
                    "ion-ios-bluetooth",
                    "ion-ios-boat",
                    "ion-ios-body",
                    "ion-ios-bonfire",
                    "ion-ios-book",
                    "ion-ios-bookmark",
                    "ion-ios-bookmarks",
                    "ion-ios-bowtie",
                    "ion-ios-briefcase",
                    "ion-ios-browsers",
                    "ion-ios-brush",
                    "ion-ios-bug",
                    "ion-ios-build",
                    "ion-ios-bulb",
                    "ion-ios-bus",
                    "ion-ios-cafe",
                    "ion-ios-calculator",
                    "ion-ios-calendar",
                    "ion-ios-call",
                    "ion-ios-camera",
                    "ion-ios-car",
                    "ion-ios-card",
                    "ion-ios-cart",
                    "ion-ios-cash",
                    "ion-ios-chatboxes",
                    "ion-ios-chatbubbles",
                    "ion-ios-checkbox",
                    "ion-ios-checkbox-outline",
                    "ion-ios-checkmark",
                    "ion-ios-checkmark-circle",
                    "ion-ios-checkmark-circle-outline",
                    "ion-ios-clipboard",
                    "ion-ios-clock",
                    "ion-ios-close",
                    "ion-ios-close-circle",
                    "ion-ios-close-circle-outline",
                    "ion-ios-cloud",
                    "ion-ios-cloud-circle",
                    "ion-ios-cloud-done",
                    "ion-ios-cloud-download",
                    "ion-ios-cloud-outline",
                    "ion-ios-cloud-upload",
                    "ion-ios-cloudy",
                    "ion-ios-cloudy-night",
                    "ion-ios-code",
                    "ion-ios-code-download",
                    "ion-ios-code-working",
                    "ion-ios-cog",
                    "ion-ios-color-fill",
                    "ion-ios-color-filter",
                    "ion-ios-color-palette",
                    "ion-ios-color-wand",
                    "ion-ios-compass",
                    "ion-ios-construct",
                    "ion-ios-contact",
                    "ion-ios-contacts",
                    "ion-ios-contract",
                    "ion-ios-contrast",
                    "ion-ios-copy",
                    "ion-ios-create",
                    "ion-ios-crop",
                    "ion-ios-cube",
                    "ion-ios-cut",
                    "ion-ios-desktop",
                    "ion-ios-disc",
                    "ion-ios-document",
                    "ion-ios-done-all",
                    "ion-ios-download",
                    "ion-ios-easel",
                    "ion-ios-egg",
                    "ion-ios-exit",
                    "ion-ios-expand",
                    "ion-ios-eye",
                    "ion-ios-eye-off",
                    "ion-ios-fastforward",
                    "ion-ios-female",
                    "ion-ios-filing",
                    "ion-ios-film",
                    "ion-ios-finger-print",
                    "ion-ios-flag",
                    "ion-ios-flame",
                    "ion-ios-flash",
                    "ion-ios-flask",
                    "ion-ios-flower",
                    "ion-ios-folder",
                    "ion-ios-folder-open",
                    "ion-ios-football",
                    "ion-ios-funnel",
                    "ion-ios-git-branch",
                    "ion-ios-git-commit",
                    "ion-ios-git-compare",
                    "ion-ios-git-merge",
                    "ion-ios-git-network",
                    "ion-ios-git-pull-request",
                    "ion-ios-glasses",
                    "ion-ios-globe",
                    "ion-ios-grid",
                    "ion-ios-hammer",
                    "ion-ios-hand",
                    "ion-ios-happy",
                    "ion-ios-headset",
                    "ion-ios-heart",
                    "ion-ios-help",
                    "ion-ios-help-buoy",
                    "ion-ios-help-circle",
                    "ion-ios-help-circle-outline",
                    "ion-ios-home",
                    "ion-ios-ice-cream",
                    "ion-ios-image",
                    "ion-ios-images",
                    "ion-ios-infinite",
                    "ion-ios-information",
                    "ion-ios-information-circle",
                    "ion-ios-information-circle-outline",
                    "ion-ios-jet",
                    "ion-ios-key",
                    "ion-ios-keypad",
                    "ion-ios-laptop",
                    "ion-ios-leaf",
                    "ion-ios-link",
                    "ion-ios-list",
                    "ion-ios-list-box",
                    "ion-ios-locate",
                    "ion-ios-lock",
                    "ion-ios-log-in",
                    "ion-ios-log-out",
                    "ion-ios-magnet",
                    "ion-ios-mail",
                    "ion-ios-mail-open",
                    "ion-ios-male",
                    "ion-ios-man",
                    "ion-ios-map",
                    "ion-ios-medal",
                    "ion-ios-medical",
                    "ion-ios-medkit",
                    "ion-ios-megaphone",
                    "ion-ios-menu",
                    "ion-ios-mic",
                    "ion-ios-mic-off",
                    "ion-ios-microphone",
                    "ion-ios-moon",
                    "ion-ios-more",
                    "ion-ios-move",
                    "ion-ios-musical-note",
                    "ion-ios-musical-notes",
                    "ion-ios-navigate",
                    "ion-ios-notifications",
                    "ion-ios-notifications-off",
                    "ion-ios-notifications-outline",
                    "ion-ios-nuclear",
                    "ion-ios-nutrition",
                    "ion-ios-open",
                    "ion-ios-options",
                    "ion-ios-outlet",
                    "ion-ios-paper",
                    "ion-ios-paper-plane",
                    "ion-ios-partly-sunny",
                    "ion-ios-pause",
                    "ion-ios-paw",
                    "ion-ios-people",
                    "ion-ios-person",
                    "ion-ios-person-add",
                    "ion-ios-phone-landscape",
                    "ion-ios-phone-portrait",
                    "ion-ios-photos",
                    "ion-ios-pie",
                    "ion-ios-pin",
                    "ion-ios-pint",
                    "ion-ios-pizza",
                    "ion-ios-planet",
                    "ion-ios-play",
                    "ion-ios-podium",
                    "ion-ios-power",
                    "ion-ios-pricetag",
                    "ion-ios-pricetags",
                    "ion-ios-print",
                    "ion-ios-pulse",
                    "ion-ios-qr-scanner",
                    "ion-ios-quote",
                    "ion-ios-radio",
                    "ion-ios-radio-button-off",
                    "ion-ios-radio-button-on",
                    "ion-ios-rainy",
                    "ion-ios-recording",
                    "ion-ios-redo",
                    "ion-ios-refresh",
                    "ion-ios-refresh-circle",
                    "ion-ios-remove",
                    "ion-ios-remove-circle",
                    "ion-ios-remove-circle-outline",
                    "ion-ios-reorder",
                    "ion-ios-repeat",
                    "ion-ios-resize",
                    "ion-ios-restaurant",
                    "ion-ios-return-left",
                    "ion-ios-return-right",
                    "ion-ios-reverse-camera",
                    "ion-ios-rewind",
                    "ion-ios-ribbon",
                    "ion-ios-rose",
                    "ion-ios-sad",
                    "ion-ios-school",
                    "ion-ios-search",
                    "ion-ios-send",
                    "ion-ios-settings",
                    "ion-ios-share",
                    "ion-ios-share-alt",
                    "ion-ios-shirt",
                    "ion-ios-shuffle",
                    "ion-ios-skip-backward",
                    "ion-ios-skip-forward",
                    "ion-ios-snow",
                    "ion-ios-speedometer",
                    "ion-ios-square",
                    "ion-ios-square-outline",
                    "ion-ios-star",
                    "ion-ios-star-half",
                    "ion-ios-star-outline",
                    "ion-ios-stats",
                    "ion-ios-stopwatch",
                    "ion-ios-subway",
                    "ion-ios-sunny",
                    "ion-ios-swap",
                    "ion-ios-switch",
                    "ion-ios-sync",
                    "ion-ios-tablet-landscape",
                    "ion-ios-tablet-portrait",
                    "ion-ios-tennisball",
                    "ion-ios-text",
                    "ion-ios-thermometer",
                    "ion-ios-thumbs-down",
                    "ion-ios-thumbs-up",
                    "ion-ios-thunderstorm",
                    "ion-ios-time",
                    "ion-ios-timer",
                    "ion-ios-train",
                    "ion-ios-transgender",
                    "ion-ios-trash",
                    "ion-ios-trending-down",
                    "ion-ios-trending-up",
                    "ion-ios-trophy",
                    "ion-ios-umbrella",
                    "ion-ios-undo",
                    "ion-ios-unlock",
                    "ion-ios-videocam",
                    "ion-ios-volume-mute",
                    "ion-ios-volume-off",
                    "ion-ios-walk",
                    "ion-ios-warning",
                    "ion-ios-watch",
                    "ion-ios-water",
                    "ion-ios-wifi",
                    "ion-ios-wine",
                    "ion-ios-woman",
                    "ion-logo-android",
                    "ion-logo-angular",
                    "ion-logo-apple",
                    "ion-logo-bitcoin",
                    "ion-logo-buffer",
                    "ion-logo-chrome",
                    "ion-logo-codepen",
                    "ion-logo-css3",
                    "ion-logo-designernews",
                    "ion-logo-dribbble",
                    "ion-logo-dropbox",
                    "ion-logo-euro",
                    "ion-logo-facebook",
                    "ion-logo-foursquare",
                    "ion-logo-freebsd-devil",
                    "ion-logo-github",
                    "ion-logo-google",
                    "ion-logo-googleplus",
                    "ion-logo-hackernews",
                    "ion-logo-html5",
                    "ion-logo-instagram",
                    "ion-logo-javascript",
                    "ion-logo-linkedin",
                    "ion-logo-markdown",
                    "ion-logo-nodejs",
                    "ion-logo-octocat",
                    "ion-logo-pinterest",
                    "ion-logo-playstation",
                    "ion-logo-python",
                    "ion-logo-reddit",
                    "ion-logo-rss",
                    "ion-logo-sass",
                    "ion-logo-skype",
                    "ion-logo-snapchat",
                    "ion-logo-steam",
                    "ion-logo-tumblr",
                    "ion-logo-tux",
                    "ion-logo-twitch",
                    "ion-logo-twitter",
                    "ion-logo-usd",
                    "ion-logo-vimeo",
                    "ion-logo-whatsapp",
                    "ion-logo-windows",
                    "ion-logo-wordpress",
                    "ion-logo-xbox",
                    "ion-logo-yahoo",
                    "ion-logo-yen",
                    "ion-logo-youtube",
                    "ion-md-add",
                    "ion-md-add-circle",
                    "ion-md-alarm",
                    "ion-md-albums",
                    "ion-md-alert",
                    "ion-md-american-football",
                    "ion-md-analytics",
                    "ion-md-aperture",
                    "ion-md-apps",
                    "ion-md-appstore",
                    "ion-md-archive",
                    "ion-md-arrow-back",
                    "ion-md-arrow-down",
                    "ion-md-arrow-dropdown",
                    "ion-md-arrow-dropdown-circle",
                    "ion-md-arrow-dropleft",
                    "ion-md-arrow-dropleft-circle",
                    "ion-md-arrow-dropright",
                    "ion-md-arrow-dropright-circle",
                    "ion-md-arrow-dropup",
                    "ion-md-arrow-dropup-circle",
                    "ion-md-arrow-forward",
                    "ion-md-arrow-round-back",
                    "ion-md-arrow-round-down",
                    "ion-md-arrow-round-forward",
                    "ion-md-arrow-round-up",
                    "ion-md-arrow-up",
                    "ion-md-at",
                    "ion-md-attach",
                    "ion-md-backspace",
                    "ion-md-barcode",
                    "ion-md-baseball",
                    "ion-md-basket",
                    "ion-md-basketball",
                    "ion-md-battery-charging",
                    "ion-md-battery-dead",
                    "ion-md-battery-full",
                    "ion-md-beaker",
                    "ion-md-beer",
                    "ion-md-bicycle",
                    "ion-md-bluetooth",
                    "ion-md-boat",
                    "ion-md-body",
                    "ion-md-bonfire",
                    "ion-md-book",
                    "ion-md-bookmark",
                    "ion-md-bookmarks",
                    "ion-md-bowtie",
                    "ion-md-briefcase",
                    "ion-md-browsers",
                    "ion-md-brush",
                    "ion-md-bug",
                    "ion-md-build",
                    "ion-md-bulb",
                    "ion-md-bus",
                    "ion-md-cafe",
                    "ion-md-calculator",
                    "ion-md-calendar",
                    "ion-md-call",
                    "ion-md-camera",
                    "ion-md-car",
                    "ion-md-card",
                    "ion-md-cart",
                    "ion-md-cash",
                    "ion-md-chatboxes",
                    "ion-md-chatbubbles",
                    "ion-md-checkbox",
                    "ion-md-checkbox-outline",
                    "ion-md-checkmark",
                    "ion-md-checkmark-circle",
                    "ion-md-checkmark-circle-outline",
                    "ion-md-clipboard",
                    "ion-md-clock",
                    "ion-md-close",
                    "ion-md-close-circle",
                    "ion-md-closed-captioning",
                    "ion-md-cloud",
                    "ion-md-cloud-circle",
                    "ion-md-cloud-done",
                    "ion-md-cloud-download",
                    "ion-md-cloud-outline",
                    "ion-md-cloud-upload",
                    "ion-md-cloudy",
                    "ion-md-cloudy-night",
                    "ion-md-code",
                    "ion-md-code-download",
                    "ion-md-code-working",
                    "ion-md-cog",
                    "ion-md-color-fill",
                    "ion-md-color-filter",
                    "ion-md-color-palette",
                    "ion-md-color-wand",
                    "ion-md-compass",
                    "ion-md-construct",
                    "ion-md-contact",
                    "ion-md-contacts",
                    "ion-md-contract",
                    "ion-md-contrast",
                    "ion-md-copy",
                    "ion-md-create",
                    "ion-md-crop",
                    "ion-md-cube",
                    "ion-md-cut",
                    "ion-md-desktop",
                    "ion-md-disc",
                    "ion-md-document",
                    "ion-md-done-all",
                    "ion-md-download",
                    "ion-md-easel",
                    "ion-md-egg",
                    "ion-md-exit",
                    "ion-md-expand",
                    "ion-md-eye",
                    "ion-md-eye-off",
                    "ion-md-fastforward",
                    "ion-md-female",
                    "ion-md-filing",
                    "ion-md-film",
                    "ion-md-finger-print",
                    "ion-md-flag",
                    "ion-md-flame",
                    "ion-md-flash",
                    "ion-md-flask",
                    "ion-md-flower",
                    "ion-md-folder",
                    "ion-md-folder-open",
                    "ion-md-football",
                    "ion-md-funnel",
                    "ion-md-git-branch",
                    "ion-md-git-commit",
                    "ion-md-git-compare",
                    "ion-md-git-merge",
                    "ion-md-git-network",
                    "ion-md-git-pull-request",
                    "ion-md-glasses",
                    "ion-md-globe",
                    "ion-md-grid",
                    "ion-md-hammer",
                    "ion-md-hand",
                    "ion-md-happy",
                    "ion-md-headset",
                    "ion-md-heart",
                    "ion-md-help",
                    "ion-md-help-buoy",
                    "ion-md-help-circle",
                    "ion-md-home",
                    "ion-md-ice-cream",
                    "ion-md-image",
                    "ion-md-images",
                    "ion-md-infinite",
                    "ion-md-information",
                    "ion-md-information-circle",
                    "ion-md-jet",
                    "ion-md-key",
                    "ion-md-keypad",
                    "ion-md-laptop",
                    "ion-md-leaf",
                    "ion-md-link",
                    "ion-md-list",
                    "ion-md-list-box",
                    "ion-md-locate",
                    "ion-md-lock",
                    "ion-md-log-in",
                    "ion-md-log-out",
                    "ion-md-magnet",
                    "ion-md-mail",
                    "ion-md-mail-open",
                    "ion-md-male",
                    "ion-md-man",
                    "ion-md-map",
                    "ion-md-medal",
                    "ion-md-medical",
                    "ion-md-medkit",
                    "ion-md-megaphone",
                    "ion-md-menu",
                    "ion-md-mic",
                    "ion-md-mic-off",
                    "ion-md-microphone",
                    "ion-md-moon",
                    "ion-md-more",
                    "ion-md-move",
                    "ion-md-musical-note",
                    "ion-md-musical-notes",
                    "ion-md-navigate",
                    "ion-md-notifications",
                    "ion-md-notifications-off",
                    "ion-md-notifications-outline",
                    "ion-md-nuclear",
                    "ion-md-nutrition",
                    "ion-md-open",
                    "ion-md-options",
                    "ion-md-outlet",
                    "ion-md-paper",
                    "ion-md-paper-plane",
                    "ion-md-partly-sunny",
                    "ion-md-pause",
                    "ion-md-paw",
                    "ion-md-people",
                    "ion-md-person",
                    "ion-md-person-add",
                    "ion-md-phone-landscape",
                    "ion-md-phone-portrait",
                    "ion-md-photos",
                    "ion-md-pie",
                    "ion-md-pin",
                    "ion-md-pint",
                    "ion-md-pizza",
                    "ion-md-planet",
                    "ion-md-play",
                    "ion-md-podium",
                    "ion-md-power",
                    "ion-md-pricetag",
                    "ion-md-pricetags",
                    "ion-md-print",
                    "ion-md-pulse",
                    "ion-md-qr-scanner",
                    "ion-md-quote",
                    "ion-md-radio",
                    "ion-md-radio-button-off",
                    "ion-md-radio-button-on",
                    "ion-md-rainy",
                    "ion-md-recording",
                    "ion-md-redo",
                    "ion-md-refresh",
                    "ion-md-refresh-circle",
                    "ion-md-remove",
                    "ion-md-remove-circle",
                    "ion-md-reorder",
                    "ion-md-repeat",
                    "ion-md-resize",
                    "ion-md-restaurant",
                    "ion-md-return-left",
                    "ion-md-return-right",
                    "ion-md-reverse-camera",
                    "ion-md-rewind",
                    "ion-md-ribbon",
                    "ion-md-rose",
                    "ion-md-sad",
                    "ion-md-school",
                    "ion-md-search",
                    "ion-md-send",
                    "ion-md-settings",
                    "ion-md-share",
                    "ion-md-share-alt",
                    "ion-md-shirt",
                    "ion-md-shuffle",
                    "ion-md-skip-backward",
                    "ion-md-skip-forward",
                    "ion-md-snow",
                    "ion-md-speedometer",
                    "ion-md-square",
                    "ion-md-square-outline",
                    "ion-md-star",
                    "ion-md-star-half",
                    "ion-md-star-outline",
                    "ion-md-stats",
                    "ion-md-stopwatch",
                    "ion-md-subway",
                    "ion-md-sunny",
                    "ion-md-swap",
                    "ion-md-switch",
                    "ion-md-sync",
                    "ion-md-tablet-landscape",
                    "ion-md-tablet-portrait",
                    "ion-md-tennisball",
                    "ion-md-text",
                    "ion-md-thermometer",
                    "ion-md-thumbs-down",
                    "ion-md-thumbs-up",
                    "ion-md-thunderstorm",
                    "ion-md-time",
                    "ion-md-timer",
                    "ion-md-train",
                    "ion-md-transgender",
                    "ion-md-trash",
                    "ion-md-trending-down",
                    "ion-md-trending-up",
                    "ion-md-trophy",
                    "ion-md-umbrella",
                    "ion-md-undo",
                    "ion-md-unlock",
                    "ion-md-videocam",
                    "ion-md-volume-mute",
                    "ion-md-volume-off",
                    "ion-md-walk",
                    "ion-md-warning",
                    "ion-md-watch",
                    "ion-md-water",
                    "ion-md-wifi",
                    "ion-md-wine",
                    "ion-md-woman"
                ]
            }
        },
        // 监控data中的数据变化
        watch: {
            // 01.树状框数据变化
            searchValue(val) {
                this.$refs.tree.filter(val)
            }
        },
        // 方法集合
        methods: {
            // 01.Form表单提交
            formSubmit() {
                this.$refs['formContent'].validate((valid) => {
                    if (valid) {
                        this.$api.post(this.formAPI, this.formContent).then((response) => {
                            this.$message.success(response)
                        })
                    }
                })
            },
            // 02.重置Form表单
            onReset() {
                this.$refs['formContent'].resetFields()
            },
            // 03.获取Form数据
            getForm() {
                this.$api.get('/api/get/power-data/', {'id': this.$route.params.id}).then((response) => {
                    this.formContent.power_class = response.data[0].power_class
                    this.formContent.parent = response.data[0].parent
                    this.formContent.title = response.data[0].title
                    this.formContent.code = response.data[0].code
                    this.formContent.content = response.data[0].content
                    this.formContent.path = response.data[0].path
                    this.formContent.icon = response.data[0].icon
                    this.formContent.sort = response.data[0].sort
                })
            },
            // 04.获取Tree数据
            getTree() {
                this.$api.get('/api/get/power-tree/').then((response) => {
                    this.tree_data = response.data
                })
            },
            // 05.树状框搜索
            searchFilter(value, data) {
                if (!value) return true
                return data.label.indexOf(value) !== -1
            },
            // 05.点击获取上级权限
            powerClick(value) {
                this.formContent.parent = value.id
            }
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.判断当前写入/修改状态
            if (this.$route.params.id) {
                // 01.01.修改状态
                this.formAPI = '/api/patch/power/?id=' + this.$route.params.id
                this.htmlSubmit = "修改"
                this.getForm()
            } else {
                // 01.02.写入状态
                this.formAPI = '/api/create/power/'
                this.htmlSubmit = "添加"
            }
            // 02.获取Tree数据
            this.getTree()
        },
    }
</script>
